exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table{width:100%!important}p{line-height:18pt!important}.register-errors{color:red}", ""]);

// exports
